import type { TextStyleValue } from '@elfsight/configurator-contracts';

export const CLASS_COMPONENT = 'payment-form';

export const TEXT_ACTION_ELEMENT_FONT_STYLE: TextStyleValue = {
  fontSize: 13,
  fontWeight: 500,
  lineHeight: '16px'
};
